import React, { Component } from 'react'
import { connect } from 'react-redux'
import classes from './MarksPager.module.scss';

import ReactPaginate from 'react-paginate';

import { setCurrentPage } from '../../../redux/marks/actions';


class MarksPager extends Component {

    handlePageChange = (page)=>{
      this.props.setCurrentPage(page.selected);
    }

    render() {
      if(this.props.totalpage >1){
        return(<ReactPaginate containerClassName={classes.Container} disabledClassName={classes.disabled} pageClassName={classes.pagenum} activeClassName={classes.selected}  previousClassName={classes.previous} nextClassName={classes.next} pageCount={this.props.totalpage} onPageChange={this.handlePageChange} initialPage={this.props.currentpage} />);
      }
      return null;
    }
}

const mapStateToProps = (state)=>{
  return {
    currentpage:state.marks.currentpage,
    totalpage:state.marks.totalpage
  }
};


export default connect(mapStateToProps, { setCurrentPage })(MarksPager);
